import safeParseUrl from '../utils/safeParseUrl';
import Link from './Link';

const PUBLIC_PATH_REGEX = /^(\/public)?\/posts\/(?:.*-)?(\w+)\/?$/;
const EMBED_PATH_REGEX = /^\/embed\/(?:.*-)?(\w+)\/?$/;

const parsePostPath = (pathname: string) => {
  const publicMatched = pathname.match(PUBLIC_PATH_REGEX);
  if (publicMatched) {
    return { isPublic: !!publicMatched[1], id: publicMatched[2] };
  }

  const embedMatched = pathname.match(EMBED_PATH_REGEX);
  if (embedMatched) {
    return { isPublic: true, id: embedMatched[1] };
  }

  return null;
};

class PublicLink extends Link {
  static sanitize(href: string): string {
    const sanitized: string = super.sanitize(href);

    const url = safeParseUrl(sanitized);
    const isSameOrigin =
      url?.host === window.location.host &&
      url.protocol === window.location.protocol;

    if (isSameOrigin) {
      const postPath = parsePostPath(url.pathname);
      if (
        postPath?.isPublic === false &&
        parsePostPath(window.location.pathname)?.id === postPath.id
      ) {
        url.pathname = window.location.pathname;
        return url.toString();
      }
    }

    return sanitized;
  }
}

export default PublicLink;
